import React from 'react';
import ReactDOM from 'react-dom/client';
import { configureApi } from '@round/api';
import { installPreloadErrorHandler } from '@round/utils';
import './index.css';
import App from './App';
import '@round/ui-kit/dist/esm/index.css';
import '@round/auth/dist/esm/index.css';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.min.css';

configureApi({ origin: import.meta.env.VITE_API_DOMAIN ?? '' });
installPreloadErrorHandler({ onError: (error) => console.error('[preloadError]', error) });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);
